import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalPages: 0,
    total: 0,
    size: 0,
    page: 1,
    productsList: [],
    productLoaderButton: false,
    productsLoading: false,
    brandData: []
}

const productsSlice = createSlice({
    name: "products",
    initialState,
    reducers: {
        setProductsObject(state, action) {
            state.productsList = action?.payload?.pagination ? [...state.productsList, ...action.payload?.productsList] : action.payload?.productsList
            state.page = action.payload.page || 0
            state.productLoaderButton = action.payload.productLoaderButton || false
            state.totalPages = action.payload?.totalPages || 0
            state.productsLoading = action.payload?.productsLoading || false
            state.size = action.payload?.size
            state.total = action.payload?.total
            state.brandData = action.payload?.brandData || []
        },
        setProductsLoading(state, actions) {
            state.productsLoading = actions.payload
        },
        setProductLoaderButton(state, actions) {
            state.productLoaderButton = actions.payload
        },
        defaultState(state, action) {
            return initialState
        },
        setProductStates(state, action) {
            const { payload: { key, value } } = action
            state[key] = value;
            return state
        },
    }
})

export const productsActions = productsSlice.actions;
export default productsSlice;